<div style="width: 24px;">
	<a *ngIf="recordUrl" [href]="recordUrl" target="_blank" (click)="$event.stopPropagation()" matTooltip="{{type}} is in your {{vendor | titlecase}} account. Click to open in {{vendor | titlecase}}.">
		<span class="export-icon {{(vendor | lowercase) || 'salesforce'}} -mt-1 mr-0"></span>
	</a>
</div>
